import { ActionTypeKeys, ActionTypes } from "../../data/types";

export interface LoginState {
  isAuthenticated: boolean;
  role: string;
}

export const loginInitialState: LoginState = {
  isAuthenticated: false,
  role: ""
};

export const loginReducer = (
  state: LoginState = loginInitialState,
  action: ActionTypes
) => {
  switch (action.type) {
    case ActionTypeKeys.LOGIN_FULFILLED: {
      return {
        ...state,
        isAuthenticated: !!action.payload.data.token
      };
    }
    case ActionTypeKeys.LOGIN_REJECTED: {
      return {
        ...state,
        isAuthenticated: false
      };
    }
    case ActionTypeKeys.LOGOUT: {
      return loginInitialState;
    }
    case ActionTypeKeys.VERIFY_TOKEN: {
      return {
        ...state,
        role: action.payload.success ? action.payload.data.role : state.role
      };
    }
    default:
      return state;
  }
};
